import { Component, OnChanges, Input, ElementRef } from '@angular/core';
import { JsonViewerService } from './json-viewer.service';
import {MatTabsModule} from '@angular/material/tabs';

@Component({
    selector: 'app-json-formatter',
    imports: [MatTabsModule],
    template: '<div></div>',
    styles: [`  

              `]
})
export class FormatterComponent implements OnChanges {
  @Input() data: any;
  @Input() openJsonObjTreeLevel: any;

  constructor( private element: ElementRef,
    private jsonViewerService:JsonViewerService) {
  }

  ngOnChanges() {
      let formatter = this.jsonViewerService.formatJSONData(this.data, this.openJsonObjTreeLevel);
      this.element.nativeElement.replaceChildren();
      this.element.nativeElement.appendChild(formatter?.render());
  }
}